import React, { useEffect, useState } from "react";
import { useCoaJobs } from "../../context/coaJobsContext";
import "./COAProgressBar.css";

const STATUS_MESSAGES = [
    "Extracting document data",
    "Analyzing cannabinoids",
    "Processing terpene profiles",
    "Classifying product color",
    "Validating results",
    "Finalizing records", 
];
 
const COAProgressBar = () => {
    const { activeJobs } = useCoaJobs();
    const [msgIndex, setMsgIndex] = useState(0);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const t = requestAnimationFrame(() => setVisible(true));
        return () => cancelAnimationFrame(t);
    }, []);

    useEffect(() => {
        const id = setInterval(() => {
            setMsgIndex((i) => (i + 1) % STATUS_MESSAGES.length);
        }, 3200);
        return () => clearInterval(id);
    }, []);

    const jobCount = activeJobs.length;

    return (
        <>
            <div className={`coa-progress-bar${visible ? " coa-progress-bar--visible" : ""}`} />
            <div className={`coa-progress-chip${visible ? " coa-progress-chip--visible" : ""}`}>
                <span className="coa-progress-chip__dot" />
                <div className="coa-progress-chip__content">
                    <span className="coa-progress-chip__label">
                        Processing {jobCount} COA{jobCount !== 1 ? "s" : ""}
                    </span>
                    <span key={msgIndex} className="coa-progress-chip__text">
                        {STATUS_MESSAGES[msgIndex]}
                    </span>
                </div>
            </div>
        </>
    );
};

export default COAProgressBar;
